/** Number of digit slots in a mask (`0` marks a digit) */
export const maskDigitCount = (mask: string) =>
  mask.split('').filter((char) => char === '0').length

/** Strips everything except digits */
export const extractDigits = (value: string) => value.replace(/\D/g, '')

/** Formats a digit string according to a mask like `00 000 00 00` */
export const formatWithMask = (value: string, mask: string) => {
  const digits = extractDigits(value).slice(0, maskDigitCount(mask))
  let result = ''
  let digitIndex = 0
  for (const char of mask) {
    if (digitIndex >= digits.length) {
      break
    }
    if (char === '0') {
      result += digits[digitIndex]
      digitIndex += 1
    } else {
      result += char
    }
  }
  return result
}
